import { EventEmitter } from 'events';
import u_isPc from '../util/u_isPc';
export interface WinU_state {
  originalScale?: number;
  scrollBar?: number;
}
export default new class Win extends EventEmitter{
  private _scrollBat:number = 0;
  private _isPc:boolean = undefined;
  private _isEn:boolean = undefined;
  private _isTouch:boolean = undefined;
  private _state: WinU_state = {};
  get isPc(): boolean {
    return this._isPc;
  }
  get isEn(): boolean {
    return this._isEn;
  }
  get isTouch(): boolean {
    return this._isTouch;
  }
  get isSp(): boolean {
    return !this._isPc;
  }
  get state(): WinU_state {
    return this._state;
  }
  constructor() {
    super();
    this._resizeHdl();
    window.addEventListener('resize',this._resizeHdl.bind(this))
  }
  _resizeHdl(){
    const scrollbar = window.innerWidth - document.body.clientWidth;
    this._state.scrollBar = scrollbar;
    this._isEn = document.querySelector('html').lang==='en';
    const _viewHeight = window.innerHeight;
    document.documentElement.style.setProperty('--vh', _viewHeight/100 + 'px');
    const _scrollTarget = document.documentElement;
    const _scrollbarWidth = window.innerWidth - _scrollTarget.clientWidth;

    const getWindowWidth = () => {
      let sw = document.documentElement.clientWidth;
      if (sw === window.innerWidth) sw -= _scrollbarWidth;
      return sw;
    };
    const sw = getWindowWidth();
    const isPc = u_isPc();
    this._isPc = isPc;
    this._isTouch =
      'ontouchstart' in window ||
      navigator.maxTouchPoints > 0 ||
      window.matchMedia('(pointer:coarse)').matches;
    let _originalScale = -1;
    let designSize = isPc
      ? { w: 1512, h: 900 }
      : { w: 384, h: 816 };
    //originalScale
    const originalScale = sw / designSize.w;
    if (_originalScale !== originalScale) {
      _originalScale = originalScale;
      document.documentElement.style.setProperty('--o-s', originalScale + 'px');
      this._state.originalScale = _originalScale;
    }
  }

}
